import { render, staticRenderFns } from "./Year04.vue?vue&type=template&id=0cbbe36e&scoped=true&"
import script from "./Year04.vue?vue&type=script&lang=js&"
export * from "./Year04.vue?vue&type=script&lang=js&"
import style0 from "./Year04.vue?vue&type=style&index=0&id=0cbbe36e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbbe36e",
  null
  
)

export default component.exports